"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressToRender = exports.renderDriverCompulsoryExcess = void 0;
var React = require("react");
var commonFunctions_1 = require("../commonFunctions");
var renderDriverCompulsoryExcess = function (interaction, vehicle) {
    var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
    var vehicleDrivers = [];
    if (vehicle.driverIds) {
        vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); }).filter(function (driver) { return driver !== undefined; });
    }
    return vehicleDrivers.map(function (driver, index) {
        var driverCompExcess = driver.excesses.adExcess + vehicle.excesses.adExcess;
        var driverDescription = driver.personId === vehicle.mainDriverId ? "main driver" : "additional driver";
        return (React.createElement("div", { className: "text-center m-0 font-weight-extra-light", key: index }, "".concat(driver.firstName, " ").concat(driver.lastName, ", "),
            React.createElement("span", { className: "font-weight-semi-bold" },
                driverDescription,
                ":"), " \u00A3".concat(driverCompExcess)));
    });
};
exports.renderDriverCompulsoryExcess = renderDriverCompulsoryExcess;
function getAddressToRender(address) {
    var addressComponents = (0, commonFunctions_1.getAddressLines)(address);
    return addressComponents.map(function (component, index) { return (index % 2 === 0) && (index < addressComponents.length - 1) ?
        React.createElement("span", { key: index, className: "detail-value" }, component) :
        React.createElement(React.Fragment, null,
            React.createElement("span", { key: index, className: "detail-value" },
                ", ",
                component),
            React.createElement("br", null)); });
}
exports.getAddressToRender = getAddressToRender;
//# sourceMappingURL=CommonRenderers.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/CommonRenderers.js
// module id = 453
// module chunks = 0